<mat-toolbar class="subtitulo">Contas Bancárias</mat-toolbar>
<div class="painel-principal" style="padding: 10px;">
    <form #formCadastro="ngForm">


        <mat-toolbar class="titulopartes">Dados da Conta</mat-toolbar>

        <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
            <!-- UNIDADE -->
            <mat-form-field fxFlex="30%" fxLayoutGap="20px" fxFlexOffset="20px">
                <mat-label>Unidade:</mat-label>
                <mat-select [(ngModel)]="contaBancaria.unidade.idUnidade" name="empresa" required>
                    <mat-option></mat-option>
                    <mat-option *ngFor="let i of unidades" [value]=i.idUnidade>
                        {{i.nomeUnidade}}
                    </mat-option>
                </mat-select>
                <mat-hint *ngIf="unidades?.length === 0" align="start">Nenhuma unidade
                    cadastrada</mat-hint>
            </mat-form-field>
            
            <!-- BANCO -->
            <mat-form-field fxFlex="30%" >
                <mat-label>Banco:</mat-label>
                <mat-select [(ngModel)]="contaBancaria.banco" name="cargo" required>
                    <mat-option></mat-option>
                    <mat-option *ngFor="let m of listaBancos" [value]=m>
                        {{m.numero}} - {{m.nome}}
                    </mat-option>
                </mat-select>
                <mat-hint *ngIf="listaBancos?.length === 0" align="start">Nenhum banco cadastrado</mat-hint>
            </mat-form-field>

            <mat-form-field fxFlex="30%" >
                <mat-label>Tipo de Contas:</mat-label>
                <mat-select name="tiposContas" 
                            [(ngModel)]="contaBancaria.tipoContaBancaria"
                            (selectionChange)="carregarListaContasAssociadas()">
                    <mat-option></mat-option>
                    <mat-option *ngFor="let m of tipoContas" [value]="m.id">
                        {{m.nome}}
                    </mat-option>
                </mat-select>
            </mat-form-field>


        </div>
        <!-- BANCOS -->
        <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
            
            <!-- AGENCIA -->
            <mat-form-field fxFlexOffset="20px" fxFlex="10%">
                <input [(ngModel)]="contaBancaria.numeroAgencia" matInput maxlength="20" name="agencia" placeholder="Agência:" required>
            </mat-form-field>

            <!-- CONTA -->
            <mat-form-field fxFlex="15%">
                <input [(ngModel)]="contaBancaria.numeroContaBancaria" matInput maxlength="20" name="conta" placeholder="Conta Corrente:" required>
            </mat-form-field>

            <mat-form-field fxFlex="60%">
                <input [(ngModel)]="contaBancaria.nomeContato" #contato matInput maxlength="200" name="nomeContato" placeholder="Nome contato:">
                <mat-hint align="end">{{nomeTitular.value.length}} / 200</mat-hint>
            </mat-form-field>
        </div>

        <div [fxHide]="contaBancaria.tipoContaBancaria === 'C'">
            <mat-toolbar class="titulopartes">Conta Associada</mat-toolbar>
            <div fxLayout="row" 
                fxLayoutGap="50px" 
                style="margin-top: 10px; margin-bottom: 10px" 
                fxFlexFill>

                <mat-form-field fxFlex="30%" fxFlexOffset="20px">
                    <mat-label>Agência - Conta Corrente</mat-label>
                    <mat-select name="tiposContas" 
                               [(ngModel)]="contaBancaria.contaAssociada"
                               (selectionChange)="carregarContaAssociada()">
                        <mat-option></mat-option>
                        <mat-option *ngFor="let m of contasAssociadas" [value]="m.id">
                            {{m.numeroAgencia}} - {{m.numeroContaBancaria}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
            <div ngModelGroup="comboRubrica" fxFlex="100%" fxLayoutGap="20px" class="marginCombo">
                <combo-rubrica  [showDisplayId]="false"
                                [obrigatorio]="false"
                                [hasSintetica]="false"
                                [selecionado]="contaBancaria.categoriasContabeis"
                                label="Conta contábil"
                                (valorChange)="carregarContaContabil($event)"
                                placeholder="Conta contábil">
                </combo-rubrica>
            </div> 
        </div>


        <mat-toolbar class="titulopartes">Dados do Titular</mat-toolbar>
        <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>

            <!-- NOME TITULAR -->
            <mat-form-field fxFlexOffset="20px" fxFlex="30%">
                <input [(ngModel)]="contaBancaria.nomeTitular" #nomeTitular matInput maxlength="200" name="nomeTitular" placeholder="Nome titular:" required>
                <mat-hint align="end">{{nomeTitular.value.length}} / 200</mat-hint>
            </mat-form-field>

            <!-- CPF/CNPJ -->
            <mat-form-field fxFlex="30%">
                <input [(ngModel)]="contaBancaria.cpfCnpjTitular" #numerocpfcnpj matInput maxlength="14" name="numerocpfcnpj" placeholder="CPF/CNPJ:" required>
                <mat-hint align="end">{{numerocpfcnpj.value.length}} / 14</mat-hint>
            </mat-form-field>

            <!-- TELEFONE -->
            <mat-form-field fxFlex="20%">
                <input matInput [(ngModel)]="contaBancaria.telefoneTitular" name="celular" placeholder="Celular"
                    [textMask]="{mask: maskCelular}"
                    pattern="^(?:\(?([1-9][0-9])\)?\s?)?(?:((?:9\d|[2-9])\d{3})\-?(\d{4}))$">
            </mat-form-field>
    
        </div>

        <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
          <!-- EMAIL -->
            <mat-form-field fxFlexOffset="20px" fxFlex="50%">
                <input email [(ngModel)]="contaBancaria.emailTitular" #email matInput maxlength="200" name="email" placeholder="Email:">
                <mat-hint align="end">{{email.value.length}} / 200</mat-hint>
            </mat-form-field>
        </div>


        <!-- BOTOES -->
        <div dir="rtl" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px"
            fxFlexFill>
            <button *ngIf="!isAtualizar && mostrarBotaoCadastrar" mat-raised-button name="botaoConfirmar" fxFlex="20%"
                color="primary" [disabled]="formCadastro.invalid" (click)="cadastrar()"> Cadastrar
            </button>

            <button *ngIf="isAtualizar && mostrarBotaoAtualizar" mat-raised-button name="botaoConfirmar" fxFlex="20%"
                color="primary" [disabled]="formCadastro.invalid" (click)="atualizar()">
                Atualizar
            </button>

            <button *ngIf="mostrarBotaoLimpar()" mat-raised-button fxFlex="20%" (click)="limpar()">
                Limpar
            </button>
            <button mat-raised-button fxFlex="20%" (click)="cancelar()">
                Cancelar
            </button>
        </div>
    </form>

</div>